module.exports = __webpack_public_path__ + "img/language.9c9d35aa.png";